const HOME_RADIUS_KM = 3;

const SENSITIVE_FIELDS_BY_SOURCE = {
  checkins: {
    lat: { action: 'reducePrecision', precision: 2 },
    lon: { action: 'reducePrecision', precision: 2 },
    venue: { action: 'label', label: 'Local privado' },
    formatted_address: { action: 'remove' },
    city: { action: 'keep' },
    country: { action: 'keep' },
    date: { action: 'keep' },
    category: { action: 'keep' },
    times_visited: { action: 'keep' },
  },
  health: {
    lat: { action: 'reducePrecision', precision: 2 },
    lon: { action: 'reducePrecision', precision: 2 },
  },
  moves: {
    lat: { action: 'reducePrecision', precision: 2 },
    lon: { action: 'reducePrecision', precision: 2 },
  },
  googleMaps: {
    lat: { action: 'reducePrecision', precision: 2 },
    lon: { action: 'reducePrecision', precision: 2 },
  },
  concerts: {
    latitude: { action: 'reducePrecision', precision: 2 },
    longitude: { action: 'reducePrecision', precision: 2 },
    venue_name: { action: 'keep' },
    city_name: { action: 'keep' },
    country_name: { action: 'keep' },
    artist_name: { action: 'keep' },
    tour_name: { action: 'keep' },
    event_date: { action: 'keep' },
  },
  diary: {
    note: { action: 'remove' },
    note_title: { action: 'label', label: 'Entrada privada' },
    activities: { action: 'remove' },
    mood: { action: 'keep' },
    entry_date: { action: 'keep' },
  },
  spotify: {
    track_name: { action: 'keep' },
    artist_name: { action: 'keep' },
    album_name: { action: 'keep' },
    played_at: { action: 'keep' },
    ms_played: { action: 'keep' },
  },
  appleMusic: {
    track_name: { action: 'keep' },
    artist_name: { action: 'keep' },
    album_name: { action: 'keep' },
    played_at: { action: 'keep' },
    ms_played: { action: 'keep' },
  },
  movies: {
    title: { action: 'keep' },
    year: { action: 'keep' },
    watched_at: { action: 'keep' },
    show_title: { action: 'keep' },
    episode_title: { action: 'keep' },
  },
  shows: {
    title: { action: 'keep' },
    year: { action: 'keep' },
    watched_at: { action: 'keep' },
    show_title: { action: 'keep' },
    episode_title: { action: 'keep' },
  },
};

const toRad = (deg) => (deg * Math.PI) / 180;

const haversineKm = (lat1, lon1, lat2, lon2) => {
  if (
    lat1 == null || lon1 == null || lat2 == null || lon2 == null
    || Number.isNaN(Number(lat1)) || Number.isNaN(Number(lon1))
    || Number.isNaN(Number(lat2)) || Number.isNaN(Number(lon2))
  ) return null;
  const R = 6371;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

const reduceCoordPrecision = (value, precision) => {
  if (value == null) return value;
  const factor = 10 ** (precision || 2);
  const num = Number(value);
  return Number.isNaN(num) ? value : Math.round(num * factor) / factor;
};

const isInsideRadius = (lat, lon, privateCenter) => {
  if (!privateCenter || !privateCenter.centerLat || !privateCenter.centerLon) return false;
  const dist = haversineKm(privateCenter.centerLat, privateCenter.centerLon, Number(lat), Number(lon));
  return dist !== null && dist <= (privateCenter.radiusKm || HOME_RADIUS_KM);
};

const redactItem = (item, sourceKey, privateCenter) => {
  if (!item || !sourceKey) return item;

  const itemLat = item.lat ?? item.latitude;
  const itemLon = item.lon ?? item.longitude;

  const isInPrivateArea = privateCenter
    && isInsideRadius(itemLat, itemLon, privateCenter);

  const isAlwaysRedacted = sourceKey === 'diary';

  if (!isInPrivateArea && !isAlwaysRedacted) return item;

  const fieldMap = SENSITIVE_FIELDS_BY_SOURCE[sourceKey] || {};
  const redacted = {};

  for (const [key, value] of Object.entries(item)) {
    const rule = fieldMap[key];
    if (!rule || rule.action === 'keep') {
      redacted[key] = value;
    } else if (rule.action === 'remove') {
      continue;
    } else if (rule.action === 'label') {
      redacted[key] = rule.label;
    } else if (rule.action === 'reducePrecision') {
      redacted[key] = reduceCoordPrecision(value, rule.precision);
    }
  }
  return redacted;
};

export const redactData = (data, privateCenter) => {
  if (!privateCenter || !data) return data;

  const redacted = {};
  for (const [sourceKey, items] of Object.entries(data)) {
    if (!Array.isArray(items)) {
      redacted[sourceKey] = items;
      continue;
    }
    redacted[sourceKey] = items.map(item => redactItem(item, sourceKey, privateCenter));
  }
  return redacted;
};

export const createEmptyPrivacyConfig = () => ({
  enabled: false,
  centerLat: null,
  centerLon: null,
  radiusKm: HOME_RADIUS_KM,
  label: 'Casa',
});

export const SENSITIVE_CLASSIFICATION = SENSITIVE_FIELDS_BY_SOURCE;
